import { render, staticRenderFns } from "./detailSensorsTank.vue?vue&type=template&id=3a645dff"
import script from "./detailSensorsTank.vue?vue&type=script&lang=js"
export * from "./detailSensorsTank.vue?vue&type=script&lang=js"
import style0 from "./detailSensorsTank.vue?vue&type=style&index=0&id=3a645dff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports